import { type ReactNode } from 'react';
import { useAppInit } from '@/app/hooks/useAppInit';
import { FullPageLoader } from '@/shared/components/ui/LoadingSpinner';
import { ErrorAlert } from '@/shared/components/ui/ErrorAlert';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { isLoading, ready, error } = useAppInit();

  if (isLoading || !ready) {
    return <FullPageLoader message="Initializing..." />;
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <ErrorAlert title="Initialization Error" message={error} />
      </div>
    );
  }

  return <>{children}</>;
}
